import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Contact } from 'app/models/contact';
import { Globals } from 'app/services/globals';
import { convertObjectArrayToIdArray } from 'app/helpers/utils';
import * as _ from "lodash";
import { FormBuilder, Validators } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class ContactService {
    private _cachedContacts: Contact[] = null;

    public get cachedContacts() : Contact[] {
        if (!this._cachedContacts) {
            this._cachedContacts = [];
            this.getAll().subscribe();
        }
        return this._cachedContacts;
    }

    constructor(private http: HttpClient, private globals: Globals, private formBuilder: FormBuilder, private userService: UserService) {
        this.userService.currentUser.subscribe(user => {
            if (user && this.globals.api_base_url) {
                this.getAll().subscribe();
            }
        });
    }
    getAll() {
        return this._cachedContacts && this._cachedContacts.length > 0 ? of(this._cachedContacts): this.http.get<Contact[]>(`${this.globals.api_base_url}/contacts`).pipe(tap(c => this._cachedContacts = c));
    }
    put(contact: Contact) {        
        return this.http.put<Contact>(`${this.globals.api_base_url}/contact`, contact).pipe(tap(() => {
            this._cachedContacts = [];
        }));
    }
    deactivate(contact: Contact) {
        return this.http.delete(`${this.globals.api_base_url}/contact/${contact.id}`).pipe(tap(() => {
            this._cachedContacts = [];
        }));
    }
    restore(contact: Contact) {
        return this.http.post(`${this.globals.api_base_url}/contact/${contact.id}/restore`, {}).pipe(tap(() => {
            this._cachedContacts = [];
        }));
    }

    // Returns a FormGroup object mapping with the contact's fields with validators sent
    formGroup() {
        return this.formBuilder.group({
            id: [undefined],
            name: ['', [Validators.maxLength(255)]],
            email: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
            tags: [[]]
        });
    }
}
